// The rules /topics and /storylines rank by (2026-10-24), in one place so
// both lists, and the pages they open, say the same thing.

export const WEEK = 7
// "Usual" is the three weeks before this one.
export const BASE_DAYS = 21
const MIN_RISING = 30
const RISING_LIFT = 2

// Trending: at least MIN_RISING articles in the last 7 days and twice its
// usual 7 days. "7× usual", "New", or null when not rising. `usual` is a
// 7 days' worth of the base period. Short on purpose (2026-11-01): the
// window is named by the list it sits in ("Last 7 days").
export function risingLabel(count, usual) {
  if (count < MIN_RISING) return null
  if ((count + 1) / (usual + 1) < RISING_LIFT) return null
  if (usual < 1) return 'New'
  return `${Math.round(count / usual)}× usual`
}

// Which coverage labels put a row under each side tab: the homepage's
// side-tab rule (utils/bias coverageFromCounts) on the row's articles in the
// period.
export const SIDE_LABELS = {
  left: ['left', 'leans_left'],
  right: ['right', 'leans_right'],
}

// A row in one or two stories leans however those stories did; the side
// tabs are about what one side kept covering.
export const MIN_SIDE_STORIES = 3

// How hard coverage leans to `side`, as on the homepage: the side's margin
// as a share of all its articles, weighted by volume so a big clearly
// one-sided row outranks a small one.
export function sideRank(lean, side) {
  const total = lean.left + lean.center + lean.right
  if (!total) return 0
  const mine = side === 'left' ? lean.left : lean.right
  const theirs = side === 'left' ? lean.right : lean.left
  return ((mine - theirs) / total) * Math.log(1 + total)
}

// The overview pages' side lists (2026-11-01, the concept Sam approved):
// "The left covered more" / "The right covered more" beside each other on
// Today, /storylines and /topics. A row qualifies when Pano's label for its
// articles in the period is Leans or Mostly that side and it has at least
// `floor` articles (8 for a story, 20 for a storyline, 40 for a topic: a
// handful of articles leans any way by chance); ranked by that side's share
// of its left and right articles; at most SIDE_N.
export const SIDE_N = 4
export const SIDE_FLOORS = { story: 8, storyline: 20, topic: 40 }

export function sideShare(lean, side) {
  const lr = (lean.left || 0) + (lean.right || 0)
  if (!lr) return 0
  return (side === 'left' ? lean.left : lean.right) / lr
}

// rows: [{ lean, leanKey, total }]; returns the side's list.
export function sideList(rows, side, floor) {
  return rows
    .filter((r) => r.total >= floor && SIDE_LABELS[side].includes(r.leanKey))
    .sort(
      (a, b) =>
        sideShare(b.lean, side) - sideShare(a.lean, side) || b.total - a.total
    )
    .slice(0, SIDE_N)
}

// The line under the side lists: how they are ranked, in a reader's words
// (2026-11-01, Sam: no article minimums or "just two made the list"; the
// floor still applies, the page just doesn't recite it).
export function sideRule({ when = '' } = {}) {
  return `Ranked by how one-sided the coverage was${when}.`
}
